import { dashboardDictionary } from "~/lang/fa/sections/dashboard"
import { languages } from "~/lang/fa/sections/languages"

export default {
  ...languages,
  users: "کاربران",
  dashboard: {
    ...dashboardDictionary,
  },
}
